import { useState } from "react";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import authService from "../../services/authService";
import SpinnerOverlay from "../SpinnerOverlay";

const LoginForm = () => {
    const [email, setEmail] = useState("");
    const { login } = useAuth();
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            setLoading(true)
            if (!email || !password) return
            const response = await authService.login(email, password);
            const { token, user } = response;
            console.log(user)
            login(token, user);
            setLoading(false)
            navigate("/eventos");
        } catch (error) {
            setLoading(false)
            window.alert(error.message);
        }
    };

    return (
        <>
            <SpinnerOverlay isLoading={loading} />
            <form onSubmit={handleSubmit} className="space-y-5 max-w-sm m-auto">
                <div>
                    <label
                        htmlFor="email"
                        className="block text-sm font-medium "
                    >
                        Email
                    </label>
                    <input
                        id="email"
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="mt-1 block w-full px-3 py-2 rounded-md shadow-sm bg-zinc-900"
                    />
                </div>

                <div>
                    <label
                        htmlFor="password"
                        className="block text-sm font-medium "
                    >
                        Contraseña
                    </label>
                    <input
                        id="password"
                        type="password"
                        placeholder="Contraseña"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="mt-1 block w-full px-3 py-2 rounded-md shadow-sm bg-zinc-900"
                    />
                </div>

                <button
                    type="submit"
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md w-full"
                >
                    Login
                </button>
            </form>
        </>
    );
};

export default LoginForm;
